import React from 'react'
import { CheckoutPage } from '../../model'
import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { ArcadeSummaryPage } from '../summary-arcade'
import { BronteSummaryPage } from '../summary-bronte'
import { SummaryNotificationProvider } from '../../component'
import { useIsAppleRetailOrder } from '../../state/checkout/hooks'
import { AppleRetailSummaryPage } from '../summary-apple-retail'

export const SummaryPage: CheckoutPage = () => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const isAppleRetailOrder = useIsAppleRetailOrder()

  let SummaryComponent = BronteSummaryPage

  if (isAppleRetailOrder) {
    SummaryComponent = AppleRetailSummaryPage
  } else if (isArcadeDesignLanguage) {
    SummaryComponent = ArcadeSummaryPage
  }

  return (
    <SummaryNotificationProvider>
      <SummaryComponent />
    </SummaryNotificationProvider>
  )
}
